import { Button, Icon } from '@scale/scaleui-radix';
import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { toast } from 'react-toastify';

const CopyButton = ({
  text,
  label,
  size = '2',
}: {
  text: string;
  label: string;
  size?: '1' | '2';
}) => (
  <Button
    variant="ghost"
    size={size}
    onClick={e => {
      e.stopPropagation();
      navigator.clipboard.writeText(text);
      toast(`Copied ${label} to clipboard`, {
        type: 'info',
        autoClose: 1000,
        position: 'bottom-right',
      });
    }}
  >
    <Icon color="neutral" icon={faCopy} size={size} label="copy" />
  </Button>
);

export default CopyButton;
